/* eslint-disable */
import Util from '@/assets/libs/util';

let cameraDevices = [];
let screenDevices = {
    face: null,
    product: null,
};

// Função para buscar e retornar todos os dispositivos de câmera
const fetchCameraDevices = async () => {
    try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        // Filtrar apenas dispositivos de vídeo (câmeras)
        cameraDevices = devices.filter((device) => device.kind === 'videoinput');
        return Util.deepCopy(cameraDevices);
    } catch (error) {
        console.error('Erro ao buscar dispositivos de câmera:', error);
        return [];
    }
};

// Função para carregar dispositivos de câmera, caso ainda não estejam carregados
const loadCameraDevices = async () => {
    if (cameraDevices.length === 0) {
        cameraDevices = await fetchCameraDevices();
    }
};

// Função para salvar as configurações de dispositivos no localStorage
const saveScreenDevicesToLocalStorage = () => {
    localStorage.setItem('screenDevices', JSON.stringify(screenDevices));
};

// Função para carregar as configurações de dispositivos do localStorage
const loadScreenDevicesFromLocalStorage = async function () {
    const storedDevices = localStorage.getItem('screenDevices');
    if (storedDevices) {
        try {
            const parsedDevices = JSON.parse(storedDevices)
            if (parsedDevices.face || parsedDevices.product) {
                screenDevices = parsedDevices;
            }
        } catch (error) {
            console.error('Erro ao carregar configurações de câmera do localStorage:', error);
        }
    }
};

// Função para inicializar as telas com dispositivos de câmera
const initializeScreenDevices = async () => {
    await loadCameraDevices();
    await loadScreenDevicesFromLocalStorage();

    // Verificar se os dispositivos salvos estão disponíveis
    const faceDeviceAvailable = cameraDevices.some(device => device.deviceId === screenDevices.face);
    const productDeviceAvailable = cameraDevices.some(device => device.deviceId === screenDevices.product);

    // Se não houver configurações válidas no localStorage, ou se as câmeras não estiverem disponíveis, definir configuração padrão
    if (!faceDeviceAvailable || !productDeviceAvailable) {
        console.log('Câmeras salvas não estão disponíveis. Configurando padrão.');

        if (cameraDevices.length === 0) {
            console.error('Nenhuma câmera disponível para configuração inicial');
            return;
        }
        if (cameraDevices.length === 1) {
            // Se houver apenas uma câmera, usa o mesmo dispositivo para ambas as telas
            screenDevices.face = cameraDevices[0].deviceId;
            screenDevices.product = cameraDevices[0].deviceId;
        } else {
            // Se houver mais de uma câmera, atribui câmeras diferentes para face e product
            screenDevices.face = cameraDevices[0].deviceId;
            screenDevices.product = cameraDevices[1].deviceId;
        }
        // Salva as configurações iniciais no localStorage
        saveScreenDevicesToLocalStorage();
    }
};

// Retorna todos os dispositivos de câmera disponíveis
const getAllCameraDevices = async () => {
    await loadCameraDevices();
    return Util.deepCopy(cameraDevices);
};

// Função para definir o dispositivo de câmera para uma tela específica
const setCameraDeviceForScreen = (screen, deviceId) => {
    if (screen !== 'face' && screen !== 'product') {
        console.error('Tela inválida:', screen);
        return;
    }
    const device = cameraDevices.find((cam) => cam.deviceId === deviceId);
    if (!device) {
        console.error('Dispositivo de câmera não encontrado:', deviceId);
        return;
    }
    screenDevices[screen] = deviceId;
    saveScreenDevicesToLocalStorage(); // Salva a configuração atualizada no localStorage
    console.log(`Dispositivo de câmera definido para a tela ${screen}: ${deviceId}`);
};

// Retorna o dispositivo de câmera configurado para uma tela específica
const getCameraDeviceForScreen = async function (screen) {
    if (screen !== 'face' && screen !== 'product') {
        console.error('Tela inválida:', screen);
        return null;
    }
    await loadScreenDevicesFromLocalStorage()
    if (!screenDevices[screen]) {
        await getAllCameraDevices();
    }
    return screenDevices[screen];
};

export default {
    fetchCameraDevices,
    getAllCameraDevices,
    setCameraDeviceForScreen,
    getCameraDeviceForScreen,
    initializeScreenDevices,  // Exporta a função para inicialização
};



// WEBPACK FOOTER //
// ./src/assets/controllers/CameraController.js